if (!customElements.get('thread-picker')) {
  customElements.define(
    'thread-picker',
    class ThreadPicker extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;

        this.pouches = Array.from(this.querySelectorAll('[data-pouch]'));
        this.threads = Array.from(this.querySelectorAll('[data-thread]'));
        this.photo = this.querySelector('.thread-picker__photo');
        this.caption = this.querySelector('.thread-picker__caption');
        this.soon = this.querySelector('.thread-picker__soon');
        this.pouchName = this.querySelector('[data-selected-pouch]');
        this.threadName = this.querySelector('[data-selected-thread]');
        this.pouchKey = '';
        this.threadKey = '';

        const background = getComputedStyle(document.body).backgroundColor;
        if (!this.style.getPropertyValue('--thread-picker-bg') && background && background !== 'rgba(0, 0, 0, 0)') {
          this.style.setProperty('--thread-picker-bg', background);
        }

        this.pouches.forEach((button) => {
          button.addEventListener('click', () => this.choosePouch(button.dataset.pouch), { signal });
        });

        this.threads.forEach((button) => {
          const warm = () => this.preload(button.dataset.thread);
          button.addEventListener('click', () => this.chooseThread(button.dataset.thread), { signal });
          button.addEventListener('pointerenter', warm, { signal });
          button.addEventListener('focus', warm, { signal });
        });

        const initial = this.pouches.find((button) => button.getAttribute('aria-pressed') === 'true') || this.pouches[0];
        if (initial) this.choosePouch(initial.dataset.pouch, true);
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        clearTimeout(this.swapTimer);
      }

      choosePouch(key, initial = false) {
        this.pouchKey = key;
        this.pouches.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.pouch === key));
        });

        this.threads.forEach((button) => {
          const offered = button.dataset.offered.split(' ').includes(key);
          button.setAttribute('aria-disabled', String(!offered));
        });

        const current = this.threads.find((button) => button.dataset.thread === this.threadKey);
        if (current && current.getAttribute('aria-disabled') === 'true') this.threadKey = '';

        this.markThreads();
        this.render(!initial);
      }

      chooseThread(key) {
        const button = this.threads.find((item) => item.dataset.thread === key);
        if (!button || button.getAttribute('aria-disabled') === 'true') return;

        this.threadKey = this.threadKey === key ? '' : key;
        this.markThreads();
        this.render(true);
      }

      markThreads() {
        this.threads.forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.thread === this.threadKey));
        });
      }

      findTemplate(id) {
        return this.querySelector('template[data-photo="' + id + '"]');
      }

      render(animate) {
        const combo = this.threadKey ? this.findTemplate(this.pouchKey + ':' + this.threadKey) : null;
        const template = combo || this.findTemplate(this.pouchKey);

        const pouchButton = this.pouches.find((button) => button.dataset.pouch === this.pouchKey);
        const threadButton = this.threads.find((button) => button.dataset.thread === this.threadKey);
        // The caption describes the photo on screen, so it names the thread only when a photo for that pair is showing.
        let text = pouchButton ? pouchButton.dataset.label + ' Pochette' : '';
        if (threadButton && combo) text += ' with ' + threadButton.dataset.label + ' thread';

        this.caption.textContent = text;
        if (this.pouchName) this.pouchName.textContent = pouchButton ? pouchButton.dataset.label : '';
        if (this.threadName) this.threadName.textContent = threadButton ? threadButton.dataset.label : '';
        if (this.soon) this.soon.hidden = !(this.threadKey && !combo);
        this.showPhoto(template, animate);
      }

      showPhoto(template, animate) {
        const swap = () => {
          this.photo.replaceChildren();
          if (template) this.photo.append(template.content.cloneNode(true));

          const img = this.photo.querySelector('img');
          const reveal = () => {
            void this.photo.offsetWidth;
            this.photo.classList.remove('is-changing');
          };

          if (img) img.loading = 'eager';
          if (img && !img.complete) {
            img.addEventListener('load', reveal, { once: true });
            img.addEventListener('error', reveal, { once: true });
          } else {
            reveal();
          }
        };

        clearTimeout(this.swapTimer);

        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          swap();
          return;
        }

        this.photo.classList.add('is-changing');
        this.swapTimer = setTimeout(swap, 180);
      }

      preload(threadKey) {
        const template = this.findTemplate(this.pouchKey + ':' + threadKey);
        const img = template && template.content.querySelector('img');
        if (!img || img.dataset.warmed) return;

        const warm = new Image();
        warm.sizes = img.getAttribute('sizes') || '';
        warm.srcset = img.getAttribute('srcset') || '';
        warm.src = img.getAttribute('src') || '';
        img.dataset.warmed = 'true';
      }
    }
  );
}